<!--
 * @Author: lishiqiao
 * @Date: 2022-01-14 10:52:46
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-07-14 10:22:00
-->
<template>
  <div class="page-list">
    <!-- 年度目标完成情况汇总表-养成 -->
    <SummaryPage v-if="pageType === 'summary'" @getPageType="getPageType" />
    <!-- 年度目标完成情况明细表-养成 -->
    <DetailPage v-if="pageType === 'detail'" @getPageType="getPageType" />
  </div>
</template>

<script>
import SummaryPage from "./yc-sales-customer-summary.vue";
import DetailPage from "./yc-sales-customer-details.vue";
export default {
  name: "yc-sales-customer",
  data() {
    return {
      pageType: "summary", // summary汇总表,detail明细表
    };
  },
  methods: {
    getPageType(pageType) {
      this.pageType = pageType;
    },
  },
  components: {
    SummaryPage,
    DetailPage,
  },
};
</script>

<style>
</style>